<div class="wrapper">
    <main-header></main-header>
    <main>
        <div class="container container-import-wizard">
            <div class="back-home-link">
                <a [routerLink]="['/import-wizard']" [queryParams]="{ projectId: projectId, step: 'Dimensions' }" class="btn btn-text"><span class="material-icons-outlined">arrow_back</span> <span class="subtitle-2">Back to Home</span></a>
            </div>
            <div class="import-blocks" [ngClass]="{'loading': loading}">
                <div class="import-block">
                    <div class="d-flex align-items-center mb-16">
                        <div class="mr-8"><span class="material-icons-outlined text-warning">warning_amber</span></div>
                        <h4>Complexity</h4>
                    </div>
                    <div>
                        <div class="body-1 mb-8">Current problem complexity is <b>{{roundedMultiplier}}</b> what the tool can comfortably handle: reduce the number of the dimensions and/or the number of the unique
                            values in scope for certain dimensions.</div>
                        <div *ngIf="showHint" class="hint-block mt-24">
                            <div class="wrap-text">
                                <p class="body-2">
                                    The table below displays the count of unique values for each dimension and the percentage reduction in data complexity achievable by either removing that dimension
                                    or focusing on its top values. The option to focus on top values is available only for dimensions that have a sufficient number of unique values and where the top
                                    values explain most of the variance.
                                </p>
                            </div>
                            <a (click)="showHint=false" class="btn-close material-icons-outlined">close</a>
                        </div>
                        <div class="mt-24">
                            <div class="d-flex justify-content-between mb-8">
                                <span class="body-2">Current complexity</span>
                                <span class="subtitle-2">{{roundedMultiplier}}</span>
                            </div>
                            <div [ngClass]="{'bar-success': multiplier <= 1,'bar-warning': multiplier > 1 && multiplier <= 2,'bar-error': multiplier > 2 }" class="bar">
                                <div class="bar-line" [style.width]="perc + '%'"></div>
                            </div>
                        </div>
                        <div class="table-container column-border table-big small-cell mt-24">
                            <!-- Header row -->
                            <div class="row header">
                                <div *ngFor="let col of columns" class="cell" [ngClass]="{ 'inactive':col.isRemoved,  'inactive-gray-bg': col.isRemoved }">
                                    <div class="subtitle-2">{{col.name}}</div>
                                    <span class="body-2">{{col.uniqueValues}} values</span>
                                </div>
                            </div>

                            <!-- Data rows -->
                            <div class="row">
                                <td *ngFor="let col of columns; let i = index" class="cell">
                                    <div *ngIf="col.removeImpact > 0 && !col.isRemoved">
                                        <a (click)="removeColumn(i)" class="body-2">Remove : {{(-col.removeImpact)}}%</a>
                                    </div>
                                    <div *ngIf="col.isRemoved">
                                        <a (click)="unremoveColumn(i)" class="font-small">
                                            Add back
                                        </a>
                                    </div>
                                </td>
                            </div>
                            <div class="row">
                                <td *ngFor="let col of columns; let i = index" class="cell">
                                    <div *ngIf="col.compactImpact > 0 && !col.isCompacted">
                                        Top <a (click)="showTopValsDialog(col.name, col.compactTopN)" class="body-2">{{col.compactTopN}} {{(-col.compactImpact)}}%</a>
                                    </div>
                                    <div *ngIf="col.isCompacted && !col.isRemoved">
                                        Top <a (click)="showTopValsDialog(col.name, col.compactTopN)" class="body-2">{{col.compactTopN}}</a> selected
                                        <br>
                                        <a (click)="removeColumnCompression(i)" class="font-small">
                                            cancel
                                        </a>
                                    </div>
                                </td>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button (click)="proceedToNextPage()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
                    </div>
                </div>
            </div>
            <div class="fit-space-block"></div>
        </div>
    </main>
    <footer>
        <span class="body-2">© DeltaWizard. All rights reserved</span>
    </footer>
</div>
